export default __webpack_public_path__ + "static/media/video.eaefffca.mp4";